/**
 * Category of news message.
 * tag: 1473
 * @readonly
 * @enum {number} (int)
 */
export enum NewsCategory {
  /** Company News */
  CompanyNews = 0,
  /** Marketplace News */
  MarketplaceNews = 1,
  /** Financial Market News */
  FinancialMarketNews = 2,
  /** Technical News */
  TechnicalNews = 3,
  /** Other News */
  OtherNews = 99,
}
